module.exports = __webpack_public_path__ + "img/PDF-small.2dabd63.svg";